import 'ol/ol.css';
import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { Cluster } from 'ol/source'
import { Style, Icon, Circle, Fill, Stroke, Text } from 'ol/style.js';
import CircleStyle from 'ol/style/Circle';

import ApiService from 'services/ApiService';
import { ToFeatures } from 'services/GeoJsonService';
import { isAccessCctv } from './CctvUtils';

export default class LayerFacilityCctv extends VectorLayer {

    constructor(map, onDataLoaded) {

        let clusterStyle = function (feature) {
            let size = feature.get('features').length;
            if (size > 1) {
                // 클러스터된 포인트일 경우
                return [
                    // 기본 아이콘
                    new Style({
                        image: new Icon({
                            anchor: [0.5, 0.5],
                            anchorXUnits: 'fraction',
                            anchorYUnits: 'fraction',
                            // src: '/images/facility/cctv_active.png',
                            src: '/images/facility/clust_cctv_bg.svg',
                        }),
                        zIndex: 1
                    }),
                    new Style({
                        // image: new CircleStyle({
                        //     offsetY: -15,
                        //     radius: 20, // 원 크기 조정 
                        //     fill: new Fill({
                        //         color: 'rgba(70,177, 254, 0.8)' // 아이콘 보더 색상과 동일 0.8 opacity
                        //     }),
                        //     displacement: [0, 13], // [x, y] 형태로 위치 조정, y에 음수 값을 주면 위로 이동
                        // }),
                        text: new Text({
                            font: 'bold 32px Pretendard, sans-serif', // 32px 
                            text: size.toString(),
                            textBaseline: "middle",
                            textAlign: "center",
                            position:"relative",
                            offsetY: 0, // 텍스트 위치 조정 
                           
                            fill: new Fill({
                                color: '#333' 
                            })
                        }),
                        zIndex: 1 
                    })
                ];
            } else {
                feature = feature.get('features')[0];
                const stat = feature.getProperties()?.properties.stat;
                return new Style({
                    image: new Icon({
                        anchor: [0.5, 0.5],
                        anchorXUnits: 'fraction',
                        anchorYUnits: 'fraction',
                        src: stat == 1 ? '/images/facility/cctv_active.png' : '/images/facility/cctv_inactive.png',
                    }),
                    zIndex: 1
                });
            }
        };
        super({
            name: 'cctvLayer',
            source: new Cluster({
                distance: 120,
                minDistance: 80,
                source: new VectorSource(),
            }),
            visible: true,
            style: clusterStyle,
            userLayer: true,
            layerIndex: 0,
        });
        this.onDataLoaded = onDataLoaded;
        this.map = map;
        this.map?.addLayer(this);
        this.setData();
    }

    setData = function () {
        const layer = this;
        ApiService.get(`newdashboard/gis/GetCCTV?_=${Date.now()}`).then(response => {
            if (response.status === 200) {
                const data = response.data;

                let dataset = new Array();
                let id, name, x, y, stat, obj;
                for (let i = 0; i < data.rows.length; i++) {
                    const row = data.rows[i];

                    // 접근로 CCTV는 일반 CCTV 아이콘에서 제외
                    if (isAccessCctv(row)) {
                        continue;
                    }

                    id = data.rows[i]['cctvId'];
                    name = data.rows[i]['cctvLocation'];
                    x = data.rows[i]['x'];
                    y = data.rows[i]['y'];
                    stat = data.rows[i]['stat'];

                    obj = { 
                        id: id, 
                        x: x, 
                        y: y, 
                        nm: name, 
                        stat: stat, 
                        type: "cctv" 
                    };
                    dataset.push(obj);
                }

                let source = this.getSource()
                if (source instanceof Cluster) {
                    source = source.getSource();
                    source.addFeatures(ToFeatures(dataset))
                } else if (source instanceof VectorSource) {
                    source.addFeatures(ToFeatures(dataset))
                }

                this.onDataLoaded?.(dataset);
            }
        })
    }
}
